module.exports = __webpack_public_path__ + "static/media/journal_audio_bg.93179c03.svg";